// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { getClientDimensionsMapping } from 'common/redux/selectors/clientSelector';
import UnitConversionHelper from 'common/helpers/UnitConversionHelper';
import withPropsOnChange from 'recompose/withPropsOnChange';
import compose from 'recompose/compose';

export const mapStateToProps = (state, ownProps) => {
    const dimensionsMapping = getClientDimensionsMapping(state, ownProps);
    return {
        dimensionsMapping
    };
};

const createUnitConverter = withPropsOnChange(
    ['dimensionsMapping'],
    ({ dimensionsMapping }) => {
        const unitConverter = new UnitConversionHelper({ dimensionsMapping });
        return {
            unitConverter
        };
    }
);

export const useUnitConverter = dimensionsMapping => {
    const [unitConverter, setUnitConverter] = React.useState(
        new UnitConversionHelper({ dimensionsMapping })
    );
    React.useEffect(() => {
        setUnitConverter(new UnitConversionHelper({ dimensionsMapping }));
    }, [dimensionsMapping]);

    return unitConverter;
};

export default compose(connect(mapStateToProps), createUnitConverter);
